module.exports = __webpack_public_path__ + "static/media/age_rating_12.ae3b8d06.svg";